import { getPortalSettingsRootUrl, getSettingsRootUrl } from './utils';
const getInboxSettingsUrl = () => `${getSettingsRootUrl()}/inboxes`;
export const getInboxAccessUrl = inboxId => `${getInboxSettingsUrl()}/${inboxId}/access`;
export const getInboxEditUrl = inboxId => `${getInboxSettingsUrl()}/edit/${inboxId}`;
export const getAvailabilityManagementUrl = () => `${getPortalSettingsRootUrl()}/availability-management`;